import React from 'react';
import { NeoGrid, Neo } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../../Common/TextConstants';
import AuthorisationVM from '../AuthorisationVM';
import { NotifyUtils } from '@singularsystems/neo-core';
import UnlockUserCommand from '../../../Models/Commands/UserCommands/UnlockUserCommand';

interface ILockedOutUsersComponentProps {
    viewModel: AuthorisationVM;
}

@observer
class LockedOutUsersView extends React.Component<ILockedOutUsersComponentProps> {

    public async submitUserUnlock(userId: string) {
        var unlockUser = new UnlockUserCommand();
        unlockUser.userId = userId;
        this.props.viewModel.taskRunner.run(async () => {
            await this.props.viewModel.usersApiClient.unlockUser(unlockUser!.toJSObject());
            NotifyUtils.add("User unlocked", "The specified user has been unlocked and will be notified.",
                "success" as any, 10);
            this.props.viewModel.loadLockedOutUsers();
        });
    }

    public render() {
        var viewModel = this.props.viewModel;
        return (
            <Neo.Tab header={TextConstants.Titles.LockedOutUsers} onDisplayed={viewModel.loadLockedOutUsers}>
                <Neo.Card title={TextConstants.Titles.LockedOutUsers} className="ml-3 mr-3">

                    <NeoGrid.Grid
                        items={viewModel.userNameLookupList} >
                        {(item, meta) => (
                            <NeoGrid.Row>
                                <NeoGrid.Column display={meta.userName} />
                                <NeoGrid.ButtonColumn>
                                    <Neo.Button
                                        onClick={() => this.submitUserUnlock(meta.userId.value)}
                                        variant="primary" >
                                        <span className="mt-1">{TextConstants.Buttons.Unlock}</span>
                                    </Neo.Button>
                                </NeoGrid.ButtonColumn>
                            </NeoGrid.Row>)}
                    </NeoGrid.Grid>

                    {viewModel.userNameLookupList.length === 0 &&
                        <div className="col-md-12 text-center">
                            <p>{TextConstants.GeneralText.NoRecords}</p>
                        </div>}

                </Neo.Card>
            </Neo.Tab>
        );
    }
}
export default LockedOutUsersView;